import * as React from "react";
import i18next from "i18next";
// Input and output is UTC but presentation is local
export var DateInput = function (props) {
    var date = typeof props.date === "string" ? new Date(props.date) : props.date;
    var _a = React.useState(formatForInput(date)), inputValue = _a[0], setInputValue = _a[1];
    React.useEffect(function () {
        setInputValue(formatForInput(date));
    }, [date]);
    return (React.createElement(React.Fragment, null,
        props.label ? React.createElement("label", { htmlFor: props.label }, props.label) : null,
        React.createElement("input", { readOnly: props.readonly || !props.onChange, disabled: props.disabled, className: "form-control", type: "date", value: (inputValue !== null && inputValue !== void 0 ? inputValue : ""), id: props.label, onChange: function (ev) {
                var _a, _b, _c, _d;
                setInputValue(ev.target.value);
                var newDateNumber = Date.parse(ev.target.value);
                if (isNaN(newDateNumber)) {
                    (_b = (_a = props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, null);
                }
                else {
                    (_d = (_c = props).onChange) === null || _d === void 0 ? void 0 : _d.call(_c, new Date(newDateNumber));
                }
            } }),
        !props.readonly ? (React.createElement("div", { className: "text-right mt-1" },
            React.createElement("button", { className: "btn btn-link p-0", onClick: function () { var _a, _b; return (_b = (_a = props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, null); } }, i18next.t("cc.date.input.remove")))) : null));
};
function formatForInput(date) {
    if (!date) {
        return "";
    }
    return date.toISOString().substr(0, 10);
}
//# sourceMappingURL=DateInput.js.map